import React, { useContext } from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert, { AlertColor } from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import UndoIcon from "@mui/icons-material/Undo";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import { Box } from "@mui/system";
import AppContext from "../../context/appContext";

interface SnackBarData {
    open: boolean;
    message: string;
    severity: AlertColor | "";
    undoFunction?: (() => Promise<void>) | false;
}

const CustomSnackbar = () => {
        const { snackBarData, setSnackBarData } = useContext(AppContext);

        if (snackBarData?.open) {
                return (
                        <Snackbar
                                open={snackBarData?.open}
                                autoHideDuration={5000}
                                onClose={() =>
                                        setSnackBarData({
                                                severity: "",
                                                undoFunction: false,
                                                message: "",
                                                open: false
                                        })}
                                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                sx={{ backgroundColor: "#3E3E3EF2", padding: "8px 10px", color: "#fff", fontSize: "16px", fontWeight: "500", borderRadius: "10px", transform: "translateX(90px)" }}
                        >
                                <Alert
                                        sx={{ display: "flex", gap: "14px", width: "100%", color: "#fff", backgroundColor: "transparent", fontWeight: "500" }}
                                        severity={snackBarData?.severity as AlertColor || "error"}
                                        icon={snackBarData?.severity === "success" ? <CheckIcon fontSize="inherit" sx={{ color: "#fff" }} /> : undefined}
                                        action={
                                                <>
                                                        {
                                                                snackBarData?.undoFunction ? (
                                                                        <IconButton size="small" onClick={async () => {
                                                                                try {
                                                                                        if (typeof snackBarData.undoFunction === "function") {
                                                                                                await snackBarData.undoFunction();
                                                                                        }
                                                                                } catch (error) {
                                                                                        console.error("Error during undo operation:", error);
                                                                                } finally {
                                                                                        setSnackBarData({
                                                                                                severity: "",
                                                                                                undoFunction: false,
                                                                                                message: "",
                                                                                                open: false
                                                                                        });
                                                                                }
                                                                        }
                                                                        }>
                                                                                <UndoIcon fontSize="small" sx={{ color: "#fff" }} />
                                                                        </IconButton>
                                                                ) : <></>
                                                        }
                                                        <IconButton size="small" onClick={() =>
                                                                setSnackBarData({
                                                                        severity: "",
                                                                        undoFunction: false,
                                                                        message: "",
                                                                        open: false
                                                                })}>
                                                                <CloseIcon sx={{ color: "#fff" }} fontSize="small" />
                                                        </IconButton>
                                                </>
                                        }
                                >
                                        <Box sx={{ color: "#fff", fontWeight: "500" }}>{snackBarData?.message}</Box>
                                </Alert>
                        </Snackbar>
                );
        } else {
                return null;
        }
};

export default CustomSnackbar;
